import { Button, Form, FormProps, Input, Select } from "antd"
import { useEffect } from "react";
import { RingotelUser, useAddRingotelUser, useUpdateRingotelUser } from "../../hooks/apis/ringotelUsers.api";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { formatPhoneNumber } from "../../utils/phoneLib";

const RingotelUserForm = (
    {
        setIsModal,
        editData,
    }: {
        setIsModal: React.Dispatch<React.SetStateAction<boolean>>
        editData: RingotelUser | null
    }
) => {
    const [form] = Form.useForm();
    const { allUsers: users } = useSelector((state: RootState) => state.users)
    const { didUsers } = useSelector((state: RootState) => state.users)
    const { data: ringotelOrgs } = useSelector((state: RootState) => state.ringotelOrgs)
    const { mutate: addRingotelUser, isLoading: isLoadingAddUser, isSuccess: isSuccessAddUser } = useAddRingotelUser()
    const { mutate: updateRingotelUser, isLoading: isLoadingUpdateUser, isSuccess: isSuccessUpdateUser } = useUpdateRingotelUser()
    const { data: ringotelUsers } = useSelector((state: RootState) => state.ringotelUsers)
    const { selectedAccount } = useSelector((state: RootState) => state.admin)

    useEffect(() => {
        form.resetFields()
    }, [])

    useEffect(() => {
        if (editData) {
            form.setFieldsValue(editData)
        } else {
            form.resetFields()
        }
    }, [editData])


    useEffect(() => {
        if (isSuccessAddUser) {
            setIsModal(false)
        }
    }, [isSuccessAddUser])


    useEffect(() => {
        if (isSuccessUpdateUser) {
            setIsModal(false)
        }
    }, [isSuccessUpdateUser])

    const onFinish: FormProps<{
        role_id: string
    }>["onFinish"] = (values: any) => {
        if (!editData) {
            addRingotelUser({
                user_id: values.user_id,
                user_ext: values.user_ext,
                account_id: selectedAccount,
                orgid: ringotelOrgs.find((org) => org.account_id === selectedAccount)?.orgid || "",
                did: values.did
            })
            return
        }
        const updateData: {
            user_id: string
            data: RingotelUser
        } = {
            user_id: editData.user_id,
            data: {
                user_id: values.user_id,
                user_ext: values.user_ext,
                account_id: selectedAccount,
                orgid: ringotelOrgs.find((org) => org.account_id === selectedAccount)?.orgid || "",
                did: values.did
            }
        }
        updateRingotelUser(updateData)
    }

    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const selectedUserId = Form.useWatch('user_id', form);

    return <Form
        style={{ padding: "10px" }}
        name="basic"
        form={form}
        labelCol={{ span: 4 }}
        onFinish={onFinish}
    >
        <Form.Item<RingotelUser>
            label="User"
            name="user_id"
            rules={[{
                required: true, validator(_, value) {
                    if (!value) {
                        return Promise.reject("Please Select User")
                    }
                    if (!editData && ringotelUsers.some(user => user.user_id === value)) {
                        return Promise.reject("User already exists")
                    }
                    return Promise.resolve();
                },
            }]}
        >
            <Select
                showSearch
                placeholder="Select User"
                optionFilterProp="children"
                defaultValue={editData ? editData.user_id : undefined}
                filterOption={filterOption}
                options={users
                    .filter(user => {
                        if (editData && user.id === editData.user_id) {
                            return true;
                        }
                        return !ringotelUsers.some(
                            ru => ru.user_id === user.id && ru.account_id === selectedAccount
                        );
                    }).map(user => {
                        return {
                            label: `${user.first_name} ${user.last_name}`,
                            value: user.id
                        }
                    })}
            />
        </Form.Item>
        <Form.Item<RingotelUser>
            name="user_ext"
            label="Extension"
            rules={[{ required: true, message: "Please input extension" }]}
        >
            <Input
                placeholder="User extension"
            />
        </Form.Item>
        <Form.Item<RingotelUser>
            name="did"
            label="Number"
            rules={[{ required: true, message: "Please select Number" }]}
        >
            <Select
                showSearch
                placeholder="Select Number"
                optionFilterProp="children"
                defaultValue={editData ? editData.did : undefined}
                filterOption={filterOption}
                options={didUsers.filter(did => {
                    return selectedUserId && selectedUserId === did.user_id;
                }).map(did => {
                    return {
                        label: formatPhoneNumber(did.did) as string,
                        value: did.did
                    }
                })}
            />
        </Form.Item>

        <Form.Item>
            <Button
                style={{ width: "100%" }}
                type="primary"
                disabled={isLoadingAddUser || isLoadingUpdateUser}
                loading={isLoadingAddUser || isLoadingUpdateUser}
                htmlType="submit"
            >
                {editData ? "Update Ringotel User" : "Add Ringotel User"}
            </Button>
        </Form.Item>
    </Form>
}
export default RingotelUserForm